import { AreaRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasAreaPicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasAreaPicker } from "./area-picker";

let loadAreaPick = !1;

export function bindAreaCanvasPickerContribution(container) {
    loadAreaPick || (loadAreaPick = !0, container.bind(CanvasAreaPicker).toDynamicValue((() => new DefaultCanvasAreaPicker(resolveContainerBinding(container, AreaRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasAreaPicker));
}
//# sourceMappingURL=area-module.js.map
